import { LoadingIndicator } from 'lib/components';
import {
  Content,
  ContentBody,
  ContentHeader,
  ContentHeaderWrap,
  ModalItem,
} from 'lib/components/modal/importModal/Components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const LoadingView = () => {
  const { t } = useTranslation();
  return (
    <ModalItem>
      <Content style={{ width: 600 }}>
        <ContentHeaderWrap>
          <ContentHeader></ContentHeader>
        </ContentHeaderWrap>
        <ContentBody>
          <LoadingIndicator isLoading={true} text={t('Importing users...')} />
        </ContentBody>
      </Content>
    </ModalItem>
  );
};
